import React from 'react';
import { Select } from 'antd';
// import { Code, UserPlus, X } from 'feather-icons-react/build/IconComponents';
// import { UserPlus } from 'feather-icons-react/build/IconComponents';
import { setSelectedCustomer } from '../../../core/redux/action';
import PropTypes from 'prop-types';


const CustomerInfo = ({ customers, selectedCustomer, dispatch }) => {
    
    const defaultCustomer = selectedCustomer || (customers.length > 0 ? customers[0].value : null);

    return (
    <div className="customer-info pos-customer-info">
        {/* <h5 className="mb-2">Customer Information</h5> */}
        <div className="d-flex align-items-center gap-2">
            <div className="">
                <Select
                    options={customers}
                    value={defaultCustomer}
                    onChange={(value) => dispatch(setSelectedCustomer(String(value)))}
                    placeholder="Choose"
                    style={{ width: '180px' }}
                    aria-label="Select customer"
                />
            </div>
            {/* <a className="btn btn-teal btn-icon fs-20" onClick={onAddCustomer}><UserPlus /></a> */}
            {/* <a href="#" className="btn btn-info btn-icon fs-20" data-bs-toggle="modal" data-bs-target="#barcode"><Code /></a> */}
        </div>
        {/* {selectedCustomer && customers.length > 1 && (
            <div className="customer-item border border-orange bg-orange-100 d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
                <div>
                    <h6 className="fs-16 fw-bold mb-1">
                        {customers.find(c => c.value === String(selectedCustomer))?.label || 'No Customer Found'}
                    </h6>
                    <div className="d-inline-flex align-items-center gap-2 customer-bonus">
                        <p className="fs-13 d-inline-flex align-items-center gap-1">
                            Bonus: <span className="badge bg-cyan fs-13 fw-bold p-1">
                                {customers.find(c => c.value === String(selectedCustomer))?.bonus || 0}
                            </span>
                        </p>
                        <p className="fs-13 d-inline-flex align-items-center gap-1">
                            Loyalty: <span className="badge bg-teal fs-13 fw-bold p-1">
                                ${customers.find(c => c.value === String(selectedCustomer))?.loyalty || 0}
                            </span>
                        </p>
                    </div>
                </div>
                <a href="#" className="btn btn-orange btn-sm">Apply</a>
                <a
                    href="#"
                    className="close-icon"
                    onClick={() => dispatch(setSelectedCustomer(''))}
                >
                    <X />
                </a>
            </div>
        )} */}
    </div>
    )
}


CustomerInfo.propTypes = {
    customers: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
            bonus: PropTypes.number,
            loyalty: PropTypes.number,
        })
    ).isRequired,
    selectedCustomer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dispatch: PropTypes.func.isRequired,
    onAddCustomer: PropTypes.func.isRequired,
};

export default CustomerInfo;